import { SET_FILTER_OPTIONS } from "./filterActions";

const initialState = {
  filterOptions: {
    date: {
      custom: {
        enabled: false,
        from: null,
        to: null
      },
      oneDay: false,
      oneWeek: false,
      oneMonth: false
    },
    clientName: [],
    duration: [],
    modified: [],
    status: null
  }
};

const filterReducer = (state = initialState, action ) => {
  switch (action.type) {
    case SET_FILTER_OPTIONS:
      return {
        ...state,
        filterOptions: { ...action.payload }
      };
    default:
      return { ...state };
  }
};

export default filterReducer;
